/**
* @vue/shared v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const j = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, Oe = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], te = () => {
}, we = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), H = Object.assign, _ = Array.isArray, b = (e) => typeof e == "function", N = (e) => typeof e == "string", Se = (e) => typeof e == "symbol", O = (e) => e !== null && typeof e == "object";
let Z;
const v = () => Z || (Z = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function W(e) {
  if (_(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const o = e[n], s = N(o) ? ke(o) : W(o);
      if (s)
        for (const r in s)
          t[r] = s[r];
    }
    return t;
  } else if (N(e) || O(e))
    return e;
}
const be = /;(?![^(]*\))/g, Ve = /:([^]+)/, Ce = /\/\*[^]*?\*\//g;
function ke(e) {
  const t = {};
  return e.replace(Ce, "").split(be).forEach((n) => {
    if (n) {
      const o = n.split(Ve);
      o.length > 1 && (t[o[0].trim()] = o[1].trim());
    }
  }), t;
}
function Y(e) {
  let t = "";
  if (N(e))
    t = e;
  else if (_(e))
    for (let n = 0; n < e.length; n++) {
      const o = Y(e[n]);
      o && (t += o + " ");
    }
  else if (O(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
/**
* @vue/reactivity v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
);
Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
);
Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(Se)
);
function ne(e) {
  return B(e) ? ne(e.__v_raw) : !!(e && e.__v_isReactive);
}
function B(e) {
  return !!(e && e.__v_isReadonly);
}
function U(e) {
  return !!(e && e.__v_isShallow);
}
function K(e) {
  return e ? !!e.__v_raw : !1;
}
function w(e) {
  const t = e && e.__v_raw;
  return t ? w(t) : e;
}
function G(e) {
  return e ? e.__v_isRef === !0 : !1;
}
/**
* @vue/runtime-core v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const S = [];
function Re(e) {
  S.push(e);
}
function De() {
  S.pop();
}
let z = !1;
function R(e, ...t) {
  if (z) return;
  z = !0;
  const n = S.length ? S[S.length - 1].component : null, o = n && n.appContext.config.warnHandler, s = Te();
  if (o)
    Q(
      o,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((r) => {
          var c, l;
          return (l = (c = r.toString) == null ? void 0 : c.call(r)) != null ? l : JSON.stringify(r);
        }).join(""),
        n && n.proxy,
        s.map(
          ({ vnode: r }) => `at <${Ee(n, r.type)}>`
        ).join(`
`),
        s
      ]
    );
  else {
    const r = [`[Vue warn]: ${e}`, ...t];
    s.length && r.push(`
`, ...xe(s)), console.warn(...r);
  }
  z = !1;
}
function Te() {
  let e = S[S.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const o = e.component && e.component.parent;
    e = o && o.vnode;
  }
  return t;
}
function xe(e) {
  const t = [];
  return e.forEach((n, o) => {
    t.push(...o === 0 ? [] : [`
`], ...Fe(n));
  }), t;
}
function Fe({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", o = e.component ? e.component.parent == null : !1, s = ` at <${Ee(
    e.component,
    e.type,
    o
  )}`, r = ">" + n;
  return e.props ? [s, ...Ie(e.props), r] : [s + r];
}
function Ie(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((o) => {
    t.push(...oe(o, e[o]));
  }), n.length > 3 && t.push(" ..."), t;
}
function oe(e, t, n) {
  return N(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : G(t) ? (t = oe(e, w(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : b(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = w(t), n ? t : [`${e}=`, t]);
}
const re = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function Q(e, t, n, o) {
  try {
    return o ? e(...o) : e();
  } catch (s) {
    se(s, t, n);
  }
}
function se(e, t, n, o = !0) {
  const s = t ? t.vnode : null, { errorHandler: r, throwUnhandledErrorInProduction: c } = t && t.appContext.config || j;
  if (t) {
    let l = t.parent;
    const a = t.proxy, h = process.env.NODE_ENV !== "production" ? re[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; l; ) {
      const g = l.ec;
      if (g) {
        for (let i = 0; i < g.length; i++)
          if (g[i](e, a, h) === !1)
            return;
      }
      l = l.parent;
    }
    if (r) {
      Q(r, null, 10, [
        e,
        a,
        h
      ]);
      return;
    }
  }
  $e(e, n, s, o, c);
}
function $e(e, t, n, o = !0, s = !1) {
  if (process.env.NODE_ENV !== "production") {
    const r = re[t];
    if (n && Re(n), R(`Unhandled error${r ? ` during execution of ${r}` : ""}`), n && De(), o)
      throw e;
    console.error(e);
  } else {
    if (s)
      throw e;
    console.error(e);
  }
}
const p = [];
let y = -1;
const k = [];
let E = null, V = 0;
const Pe = /* @__PURE__ */ Promise.resolve();
let q = null;
const Ae = 100;
function Me(e) {
  let t = y + 1, n = p.length;
  for (; t < n; ) {
    const o = t + n >>> 1, s = p[o], r = T(s);
    r < e || r === e && s.flags & 2 ? t = o + 1 : n = o;
  }
  return t;
}
function He(e) {
  if (!(e.flags & 1)) {
    const t = T(e), n = p[p.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= T(n) ? p.push(e) : p.splice(Me(t), 0, e), e.flags |= 1, ie();
  }
}
function ie() {
  q || (q = Pe.then(ce));
}
function ve(e) {
  _(e) ? k.push(...e) : E && e.id === -1 ? E.splice(V + 1, 0, e) : e.flags & 1 || (k.push(e), e.flags |= 1), ie();
}
function Ue(e) {
  if (k.length) {
    const t = [...new Set(k)].sort(
      (n, o) => T(n) - T(o)
    );
    if (k.length = 0, E) {
      E.push(...t);
      return;
    }
    for (E = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), V = 0; V < E.length; V++) {
      const n = E[V];
      process.env.NODE_ENV !== "production" && le(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2);
    }
    E = null, V = 0;
  }
}
const T = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function ce(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (n) => le(e, n) : te;
  try {
    for (y = 0; y < p.length; y++) {
      const n = p[y];
      if (n && !(n.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(n))
          continue;
        n.flags & 4 && (n.flags &= -2), Q(
          n,
          n.i,
          n.i ? 15 : 14
        ), n.flags & 4 || (n.flags &= -2);
      }
    }
  } finally {
    for (; y < p.length; y++) {
      const n = p[y];
      n && (n.flags &= -2);
    }
    y = -1, p.length = 0, Ue(e), q = null, (p.length || k.length) && ce(e);
  }
}
function le(e, t) {
  const n = e.get(t) || 0;
  if (n > Ae) {
    const o = t.i, s = o && ye(o.type);
    return se(
      `Maximum recursive updates exceeded${s ? ` in component <${s}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, n + 1), !1;
}
const L = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (v().__VUE_HMR_RUNTIME__ = {
  createRecord: J(ze),
  rerender: J(Le),
  reload: J(Je)
});
const $ = /* @__PURE__ */ new Map();
function ze(e, t) {
  return $.has(e) ? !1 : ($.set(e, {
    initialDef: P(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function P(e) {
  return Ne(e) ? e.__vccOpts : e;
}
function Le(e, t) {
  const n = $.get(e);
  n && (n.initialDef.render = t, [...n.instances].forEach((o) => {
    t && (o.render = t, P(o.type).render = t), o.renderCache = [], o.update();
  }));
}
function Je(e, t) {
  const n = $.get(e);
  if (!n) return;
  t = P(t), ee(n.initialDef, t);
  const o = [...n.instances];
  for (let s = 0; s < o.length; s++) {
    const r = o[s], c = P(r.type);
    let l = L.get(c);
    l || (c !== n.initialDef && ee(c, t), L.set(c, l = /* @__PURE__ */ new Set())), l.add(r), r.appContext.propsCache.delete(r.type), r.appContext.emitsCache.delete(r.type), r.appContext.optionsCache.delete(r.type), r.ceReload ? (l.add(r), r.ceReload(t.styles), l.delete(r)) : r.parent ? He(() => {
      r.parent.update(), l.delete(r);
    }) : r.appContext.reload ? r.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), r.root.ce && r !== r.root && r.root.ce._removeChildStyle(c);
  }
  ve(() => {
    L.clear();
  });
}
function ee(e, t) {
  H(e, t);
  for (const n in e)
    n !== "__file" && !(n in t) && delete e[n];
}
function J(e) {
  return (t, n) => {
    try {
      return e(t, n);
    } catch (o) {
      console.error(o), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let C, x = [];
function ae(e, t) {
  var n, o;
  C = e, C ? (C.enabled = !0, x.forEach(({ event: s, args: r }) => C.emit(s, ...r)), x = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((o = (n = window.navigator) == null ? void 0 : n.userAgent) != null && o.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((r) => {
    ae(r, t);
  }), setTimeout(() => {
    C || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, x = []);
  }, 3e3)) : x = [];
}
let A = null, je = null;
const Be = (e) => e.__isTeleport;
function ue(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, ue(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
v().requestIdleCallback;
v().cancelIdleCallback;
const Ke = Symbol.for("v-ndc"), qe = {};
process.env.NODE_ENV !== "production" && (qe.ownKeys = (e) => (R(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
const We = {}, fe = (e) => Object.getPrototypeOf(e) === We, Ye = (e) => e.__isSuspense, pe = Symbol.for("v-fgt"), Ge = Symbol.for("v-txt"), Qe = Symbol.for("v-cmt"), Xe = Symbol.for("v-stc"), F = [];
let d = null;
function ut(e = !1) {
  F.push(d = e ? null : []);
}
function Ze() {
  F.pop(), d = F[F.length - 1] || null;
}
function et(e) {
  return e.dynamicChildren = d || Oe, Ze(), d && d.push(e), e;
}
function ft(e, t, n, o, s, r) {
  return et(
    he(
      e,
      t,
      n,
      o,
      s,
      r,
      !0
    )
  );
}
function tt(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
const nt = (...e) => _e(
  ...e
), de = ({ key: e }) => e ?? null, I = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? N(e) || G(e) || b(e) ? { i: A, r: e, k: t, f: !!n } : e : null);
function he(e, t = null, n = null, o = 0, s = null, r = e === pe ? 0 : 1, c = !1, l = !1) {
  const a = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && de(t),
    ref: t && I(t),
    scopeId: je,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: r,
    patchFlag: o,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: A
  };
  return l ? (X(a, n), r & 128 && e.normalize(a)) : n && (a.shapeFlag |= N(n) ? 8 : 16), process.env.NODE_ENV !== "production" && a.key !== a.key && R("VNode created with invalid key (NaN). VNode type:", a.type), // avoid a block node from tracking itself
  !c && // has current parent block
  d && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (a.patchFlag > 0 || r & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  a.patchFlag !== 32 && d.push(a), a;
}
const me = process.env.NODE_ENV !== "production" ? nt : _e;
function _e(e, t = null, n = null, o = 0, s = null, r = !1) {
  if ((!e || e === Ke) && (process.env.NODE_ENV !== "production" && !e && R(`Invalid vnode type when creating vnode: ${e}.`), e = Qe), tt(e)) {
    const l = M(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && X(l, n), !r && d && (l.shapeFlag & 6 ? d[d.indexOf(e)] = l : d.push(l)), l.patchFlag = -2, l;
  }
  if (Ne(e) && (e = e.__vccOpts), t) {
    t = ot(t);
    let { class: l, style: a } = t;
    l && !N(l) && (t.class = Y(l)), O(a) && (K(a) && !_(a) && (a = H({}, a)), t.style = W(a));
  }
  const c = N(e) ? 1 : Ye(e) ? 128 : Be(e) ? 64 : O(e) ? 4 : b(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && c & 4 && K(e) && (e = w(e), R(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), he(
    e,
    t,
    n,
    o,
    s,
    c,
    r,
    !0
  );
}
function ot(e) {
  return e ? K(e) || fe(e) ? H({}, e) : e : null;
}
function M(e, t, n = !1, o = !1) {
  const { props: s, ref: r, patchFlag: c, children: l, transition: a } = e, h = t ? st(s || {}, t) : s, g = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: h,
    key: h && de(h),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && r ? _(r) ? r.concat(I(t)) : [r, I(t)] : I(t)
    ) : r,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && c === -1 && _(l) ? l.map(ge) : l,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== pe ? c === -1 ? 16 : c | 16 : c,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: a,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && M(e.ssContent),
    ssFallback: e.ssFallback && M(e.ssFallback),
    placeholder: e.placeholder,
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return a && o && ue(
    g,
    a.clone(g)
  ), g;
}
function ge(e) {
  const t = M(e);
  return _(e.children) && (t.children = e.children.map(ge)), t;
}
function rt(e = " ", t = 0) {
  return me(Ge, null, e, t);
}
function pt(e, t) {
  const n = me(Xe, null, e);
  return n.staticCount = t, n;
}
function X(e, t) {
  let n = 0;
  const { shapeFlag: o } = e;
  if (t == null)
    t = null;
  else if (_(t))
    n = 16;
  else if (typeof t == "object")
    if (o & 65) {
      const s = t.default;
      s && (s._c && (s._d = !1), X(e, s()), s._c && (s._d = !0));
      return;
    } else
      n = 32, !t._ && !fe(t) && (t._ctx = A);
  else b(t) ? (t = { default: t, _ctx: A }, n = 32) : (t = String(t), o & 64 ? (n = 16, t = [rt(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function st(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (const s in o)
      if (s === "class")
        t.class !== o.class && (t.class = Y([t.class, o.class]));
      else if (s === "style")
        t.style = W([t.style, o.style]);
      else if (we(s)) {
        const r = t[s], c = o[s];
        c && r !== c && !(_(r) && r.includes(c)) && (t[s] = r ? [].concat(r, c) : c);
      } else s !== "" && (t[s] = o[s]);
  }
  return t;
}
{
  const e = v(), t = (n, o) => {
    let s;
    return (s = e[n]) || (s = e[n] = []), s.push(o), (r) => {
      s.length > 1 ? s.forEach((c) => c(r)) : s[0](r);
    };
  };
  t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => n
  ), t(
    "__VUE_SSR_SETTERS__",
    (n) => n
  );
}
process.env.NODE_ENV;
const it = /(?:^|[-_])(\w)/g, ct = (e) => e.replace(it, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function ye(e, t = !0) {
  return b(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Ee(e, t, n = !1) {
  let o = ye(t);
  if (!o && t.__file) {
    const s = t.__file.match(/([^/\\]+)\.\w+$/);
    s && (o = s[1]);
  }
  if (!o && e && e.parent) {
    const s = (r) => {
      for (const c in r)
        if (r[c] === t)
          return c;
    };
    o = s(
      e.components || e.parent.type.components
    ) || s(e.appContext.components);
  }
  return o ? ct(o) : n ? "App" : "Anonymous";
}
function Ne(e) {
  return b(e) && "__vccOpts" in e;
}
function lt() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, o = { style: "color:#eb2f96" }, s = {
    __vue_custom_formatter: !0,
    header(i) {
      if (!O(i))
        return null;
      if (i.__isVue)
        return ["div", e, "VueInstance"];
      if (G(i)) {
        const u = i.value;
        return [
          "div",
          {},
          ["span", e, g(i)],
          "<",
          l(u),
          ">"
        ];
      } else {
        if (ne(i))
          return [
            "div",
            {},
            ["span", e, U(i) ? "ShallowReactive" : "Reactive"],
            "<",
            l(i),
            `>${B(i) ? " (readonly)" : ""}`
          ];
        if (B(i))
          return [
            "div",
            {},
            ["span", e, U(i) ? "ShallowReadonly" : "Readonly"],
            "<",
            l(i),
            ">"
          ];
      }
      return null;
    },
    hasBody(i) {
      return i && i.__isVue;
    },
    body(i) {
      if (i && i.__isVue)
        return [
          "div",
          {},
          ...r(i.$)
        ];
    }
  };
  function r(i) {
    const u = [];
    i.type.props && i.props && u.push(c("props", w(i.props))), i.setupState !== j && u.push(c("setup", i.setupState)), i.data !== j && u.push(c("data", w(i.data)));
    const f = a(i, "computed");
    f && u.push(c("computed", f));
    const m = a(i, "inject");
    return m && u.push(c("injected", m)), u.push([
      "div",
      {},
      [
        "span",
        {
          style: o.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: i }]
    ]), u;
  }
  function c(i, u) {
    return u = H({}, u), Object.keys(u).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        i
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(u).map((f) => [
          "div",
          {},
          ["span", o, f + ": "],
          l(u[f], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function l(i, u = !0) {
    return typeof i == "number" ? ["span", t, i] : typeof i == "string" ? ["span", n, JSON.stringify(i)] : typeof i == "boolean" ? ["span", o, i] : O(i) ? ["object", { object: u ? w(i) : i }] : ["span", n, String(i)];
  }
  function a(i, u) {
    const f = i.type;
    if (b(f))
      return;
    const m = {};
    for (const D in i.ctx)
      h(f, D, u) && (m[D] = i.ctx[D]);
    return m;
  }
  function h(i, u, f) {
    const m = i[f];
    if (_(m) && m.includes(u) || O(m) && u in m || i.extends && h(i.extends, u, f) || i.mixins && i.mixins.some((D) => h(D, u, f)))
      return !0;
  }
  function g(i) {
    return U(i) ? "ShallowRef" : i.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(s) : window.devtoolsFormatters = [s];
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* vue v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function at() {
  lt();
}
process.env.NODE_ENV !== "production" && at();
export {
  pt as a,
  he as b,
  ft as c,
  ut as o
};
//# sourceMappingURL=vue.runtime.esm-bundler-CT4BZx-H.js.map
